import { Routes } from '@angular/router';
// routes
import { hadiahRetailerRoutes } from './hadiah-retailer/hadiah-retailer.routes';
import { distributorRoutes } from './distributor/distributor.routes';
import { retailerRoutes } from './retailer/retailer.routes';
import { purchaseOrderRoutes } from './purchase-order/purchase-order.routes';
import { salesOrderRoutes } from './sales-order/sales-order.routes';
import { spmRoutes } from './spm/spm.routes';
import { deliveryOrderRoutes } from './delivery-order/delivery-order.routes';
import { productRoutes } from './products/products.routes';
import { adminSettingsRoutes } from './adminsettings/admin-settings.routes';
import { salesMarketingRoutes } from './sales-marketing/sales-marketing.routes';
import { aktivitasFaRoutes } from './aktivitas-fa/aktivitas-fa.routes';
import { masterDataRoutes } from './master-data/master-data.routes';
import { reportRoutes } from './report/report.routes';
import { adminCmsRoutes } from './admin-cms/admin-cms.routes';
import { monitoringFaRoutes } from './monitoring-fa/monitoring-fa.routes';

const Routing: Routes = [
  // DISTRIBUTOR
  ...distributorRoutes,
  // RETAILER
  ...retailerRoutes,
  // PURCHASE ORDER
  ...purchaseOrderRoutes,
  // SALES ORDER
  ...salesOrderRoutes,
  // SPM Order
  ...spmRoutes,
  // DELIVERY ORDER
  ...deliveryOrderRoutes,
  // Products
  ...productRoutes,
  // ADMIN SETTINGS
  ...adminSettingsRoutes,
  // Sales Marketing
  ...salesMarketingRoutes,
  // AKTIVITAS FA
  ...aktivitasFaRoutes,
  // HADIAH RETAILER (di src/app/pages/hadiah-retailer/hadiah-retailer.routes.ts)
  // Reward Setting (dulu top-level, berisi Reward Produk & Hadiah Retailer) sudah
  // dihapus total — kedua child-nya dipindah ke sini (Hadiah Scan QR & Hadiah Naik
  // Level), sehingga Reward Setting tidak punya isi lagi.
  ...hadiahRetailerRoutes,
  // Master Data
  ...masterDataRoutes,
  // Report
  ...reportRoutes,
  // Monitoring
  ...monitoringFaRoutes,
  // Admin CMS
  ...adminCmsRoutes,
  {
    path: '',
    redirectTo: 'distributor/teregistrasi/active',
    pathMatch: 'full',
  },

  {
    path: '**',
    redirectTo: 'error/404',
  },
];

export { Routing };
